/** Shared layout widths — header + main content stay aligned. */
export const LAYOUT_MAX = {
  content: { base: "100%", xl: "1280px", "2xl": "1440px" },
  header: { base: "100%", xl: "1280px", "2xl": "1440px" },
} as const;

export const LAYOUT_PX = { base: 3, sm: 4, md: 6, lg: 8, xl: 10 } as const;
